import { BASE_URL_V2 } from '@~/constants/api';

import actions from './index';

export const ACTIONS = {
  PATCH: 'WORKSHEET_ATTEMPTS_PATCH',
  PATCH_SUCCESS: 'WORKSHEET_ATTEMPTS_PATCH_SUCCESS',
  PATCH_FAILURE: 'WORKSHEET_ATTEMPTS_PATCH_FAILURE',
};

export const patch = actions.patch(
  attemptId => `${BASE_URL_V2}/student-attempts/${attemptId}/`,
  {
    PENDING: ACTIONS.PATCH,
    SUCCESS: ACTIONS.PATCH_SUCCESS,
    FAILURE: ACTIONS.PATCH_FAILURE,
  },
);
